if (!customElements.get('store-locator-section')) {
  customElements.define(
    'store-locator-section',
    class StoreLocatorSection extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-store-search]');
        this.items = Array.from(this.querySelectorAll('[data-store-item]'));
        this.countEl = this.querySelector('[data-result-count]');
        this.emptyEl = this.querySelector('[data-empty-state]');
        this.gridEl = this.querySelector('[data-store-grid]');

        this.input?.addEventListener('input', () => this.filter());
        this.filter();
      }

      filter() {
        const query = (this.input?.value || '').trim().toLowerCase();
        let visibleCount = 0;

        this.items.forEach((item) => {
          const haystack = (item.dataset.searchText || '').toLowerCase();
          const isMatch = query === '' || haystack.includes(query);
          item.classList.toggle('is-hidden', !isMatch);
          if (isMatch) visibleCount += 1;
        });

        if (this.countEl) {
          this.countEl.textContent = this.formatCount(visibleCount);
        }

        if (this.emptyEl) {
          this.emptyEl.hidden = visibleCount > 0;
        }

        if (this.gridEl) {
          this.gridEl.hidden = visibleCount === 0 && query !== '';
        }
      }

      formatCount(count) {
        const template = this.dataset.resultsTemplate || '{count} results';
        return template.replace('{count}', count);
      }
    }
  );
}
